import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "certification-summary" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = {
  class: "certification-details",
  id: "certification-details"
}
const _hoisted_4 = { class: "certification-detail-section" }
const _hoisted_5 = { class: "certification-detail" }
const _hoisted_6 = { class: "fw-700" }
const _hoisted_7 = { class: "certification-detail" }
const _hoisted_8 = { class: "fw-700" }
const _hoisted_9 = { class: "certification-detail" }
const _hoisted_10 = { class: "fw-700" }
const _hoisted_11 = { class: "certification-detail-section" }
const _hoisted_12 = { class: "certification-detail" }
const _hoisted_13 = { class: "fw-700" }

import { ref } from "vue";
import CollapsibleSection from "@/components/transitions/CollapsibleSection.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificationRequestDetails',
  props: {
    enrollmentTerm: {},
    requestedAmount: {},
    schoolName: {},
    statusLastUpdated: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const showingDetails = ref<boolean>(false);

function toggleDetails(flag: boolean) {
  showingDetails.value = flag;
}

__expose({
  showingDetails,
  toggleDetails,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CollapsibleSection, {
      inverted: showingDetails.value === true,
      isVisible: showingDetails.value,
      onToggle: _cache[1] || (_cache[1] = ($event: any) => (showingDetails.value = !showingDetails.value))
    }, {
      toggle: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "link-styled-button text-underline",
          "aria-expanded": showingDetails.value ? 'true' : 'false',
          "aria-controls": "certification-details",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showingDetails.value = !showingDetails.value), ["prevent"]))
        }, _toDisplayString(showingDetails.value ? "Hide" : "View") + " Details ", 9, _hoisted_2)
      ]),
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "School: ", -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.schoolName), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "Fund Requested Amount: ", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(__props.requestedAmount), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Funding Term: ", -1)),
              _createElementVNode("span", _hoisted_10, _toDisplayString(__props.enrollmentTerm), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Status Last Updated: ", -1)),
              _createElementVNode("span", _hoisted_13, _toDisplayString(__props.statusLastUpdated), 1)
            ])
          ])
        ], 512), [
          [_vShow, showingDetails.value]
        ])
      ]),
      _: 1
    }, 8, ["inverted", "isVisible"])
  ]))
}
}

})